import { createStore } from "redux";
import { ReducerSignUp } from "./reducer";

export const Store = createStore(ReducerSignUp)


